import React, { Component, Fragment } from "react";
import ConfirmButton from "./../../../components/buttons/ConfirmButton";
import Modal from "./../../../components/modalComponent/ModalComponent";
import ImportFormContainer from "../../ImportFormContainer";
import { ACCESS, SERVICES } from "../../../configs/constants";
import AuthRender from "../../AuthRender";
class ImportKpi extends Component {
  state = { showModal: false };
  render() {
    return (
      <AuthRender minRole={1}>
        <Fragment>
          <Modal
            title="Importer des KPIs"
            showModal={this.state.showModal}
            closeModal={() => this.setState({ showModal: false })}
            {...this.props}
          >
            <div>
              <ImportFormContainer {...this.props} title="kpis" importUri={"kpis"} />
            </div>
          </Modal>
          <div class="p-mrg-right">
            <ConfirmButton label="Importer des KPIs" large={true} onClick={() => this.setState({ showModal: true })} />
          </div>
        </Fragment>
      </AuthRender>
    );
  }
}
export default ImportKpi;



// WEBPACK FOOTER //
// src/containers/admin/kpis/ImportKpi.js